"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createWsLink = createWsLink;

var _apolloLinkWs = require("apollo-link-ws");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function createWsLink({
  getToken,
  getLanguageCode,
  uri: baseUri,
  subscriptionClient
}) {
  if (!baseUri) return undefined;
  const uri = baseUri.replace('https://', 'wss://').replace('http://', 'ws://');
  return new _apolloLinkWs.WebSocketLink(subscriptionClient ? subscriptionClient : {
    uri,
    options: {
      reconnect: true,
      lazy: true,
      connectionParams: () => {
        const token = getToken();
        return _objectSpread(_objectSpread({}, token ? {
          authorization: `Bearer ${token}`
        } : {}), {}, {
          acceptLanguage: getLanguageCode()
        });
      }
    }
  });
}